module.exports = __webpack_public_path__ + "media/images/home/map_product-9a3f633dbd3f6337698d0f256e709d89.png";